// src/modules/Courier/pages/CourierModal/pages/Scanners/ScannerV1.jsx
import React, { useEffect, useRef, useState } from 'react';
import { BrowserMultiFormatReader } from '@zxing/library';
import styles from './styles/ScannerV1.module.css';

export default function ScannersV1({ onMarkScanned, onPhotoCaptured }) {
  const videoRef           = useRef(null);
  const readerRef          = useRef(new BrowserMultiFormatReader());
  const streamRef          = useRef(null);
  const abortControllerRef = useRef(null);
  const canvasRef          = useRef(null);
  const [torchOn, setTorchOn] = useState(false);

  useEffect(() => {
    startScanner();
    return stopScanner;
  }, []);

  async function startScanner() {
    if (streamRef.current) return;
    abortControllerRef.current?.abort();
    abortControllerRef.current = new AbortController();

    try {
      const devices = await readerRef.current.listVideoInputDevices();
      const back    = devices.find(d => d.label.toLowerCase().includes('back'));
      const deviceId = back?.deviceId || devices[0]?.deviceId;
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { deviceId },
        signal: abortControllerRef.current.signal
      });
      streamRef.current = stream;
      videoRef.current.srcObject = stream;

      readerRef.current.decodeFromVideoDevice(
        deviceId,
        videoRef.current,
        (result, error) => {
          if (result) {
            onMarkScanned(result.getText());
          }
        }
      );
    } catch (e) {
      console.error('Ошибка запуска сканера:', e);
    }
  }

  function stopScanner() {
    abortControllerRef.current?.abort();
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(t => t.stop());
      streamRef.current = null;
    }
    try {
      readerRef.current.reset();
    } catch {}
  }

  async function toggleTorch() {
    if (!streamRef.current) return;
    const track = streamRef.current.getVideoTracks()[0];
    const caps  = track.getCapabilities();
    if (!caps.torch) return;
    try {
      await track.applyConstraints({ advanced: [{ torch: !torchOn }] });
      setTorchOn(on => !on);
    } catch (e) {
      console.error('Не удалось переключить torch:', e);
    }
  }

  function capturePhoto() {
    const video  = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !canvas) return;
    canvas.width  = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0);
    canvas.toBlob(blob => blob && onPhotoCaptured(blob), 'image/png');
  }

  return (
    <div className={styles.container}>
      <video ref={videoRef} className={styles.video} autoPlay muted playsInline />
      <canvas ref={canvasRef} className={styles.hidden} />

      <div className={styles.controls}>
        <button 
          type="button"
          className={styles.btn}
          onClick={toggleTorch}
          title={torchOn ? 'Фонарик: ВЫКЛ' : 'Фонарик: ВКЛ'}
        >
          <i className={`bi ${torchOn ? 'bi-lightbulb-fill' : 'bi-lightbulb'}`} />
        </button>

        <button 
          type="button"
          className={styles.btn}
          onClick={capturePhoto}
          title="Сделать фото"
        >
          <i className="bi bi-camera-fill" />
        </button>
      </div>
    </div>
  );
}
